export default "/images/Biopharm.svg?4c7bd3f817b4050a1d1e0f01e5ba0a12";